export const capitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const formatNumber = (num: number) => {
  return new Intl.NumberFormat().format(num);
};

export function applySorting<T>(
  items: T[],
  descriptor: { column: string; direction: 'ascending' | 'descending' }
) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return [...items].sort((a: any, b: any) => {
    const first = a[descriptor.column];
    const second = b[descriptor.column];

    let cmp = 0;
    if (typeof first === 'string' && typeof second === 'string') {
      cmp = first.localeCompare(second, undefined, { sensitivity: 'base' });
    } else {
      cmp = first < second ? -1 : first > second ? 1 : 0;
    }

    return descriptor.direction === 'descending' ? -cmp : cmp;
  });
}
